'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';
import type { BlogCardData } from '@/utils/blog-card-data';

import { BlogCard } from '@eliadmin/core/src/components/blog/blog-card';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { LuArrowUpRight } from 'react-icons/lu';

export function Blogs({ blogs, title }: { blogs: (Blog | BlogCardData)[]; title: string }) {
  const { t } = useTranslations();

  return (
    <section className={cn('custom-section', 'section-padding-l-center', 'generic-gap')}>
      <Heading title={title} className={{ container: 'items-center justify-center text-center' }} />
      <div className={cn('custom-container', 'grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-3')}>
        {blogs.map(blog => (
          <BlogCard blog={blog} key={blog.id} />
        ))}
      </div>
      <Button asChild variant={'white'} className="w-full sm:w-fit">
        <Link href={ROUTES.BLOG()} prefetchOnHover>
          {t('text474')} <LuArrowUpRight size={20} />
        </Link>
      </Button>
    </section>
  );
}
